import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService } from '../services';

@Component({
  template: `
    <div
      class="auth-wrapper d-flex no-block justify-content-center align-items-center"
    >
      <div class="auth-box">
        <div>
          <h5 class="font-medium m-b-20">Loading User Details</h5>
        </div>
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthCallbackView implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.completeAuthentication();
  }
}
